import { Dispatch, SetStateAction, createContext, useContext, useState } from 'react';

import { getLatestBrandTemplate } from './BrandTemplatePreview.helpers';
import { BrandTemplateData } from './BrandTemplatePreview.type';

type BrandTemplatePreviewProps = {
  children: React.ReactNode;
  templateBrandData?: BrandTemplateData;
};

interface BrandTemplatePreviewContextInterface {
  isLoading: boolean;
  hasError: boolean;
  brandTemplateData?: BrandTemplateData;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  setHasError: Dispatch<SetStateAction<boolean>>;
  setBrandTemplateData: Dispatch<SetStateAction<BrandTemplateData | undefined>>;
}

export const BrandTemplatePreviewContext = createContext<BrandTemplatePreviewContextInterface>({
  isLoading: false,
  hasError: false,
  brandTemplateData: undefined,
  setIsLoading: () => {},
  setHasError: () => {},
  setBrandTemplateData: () => {},
});

export const useBrandTemplatePreview = () => {
  return useContext(BrandTemplatePreviewContext);
};

export const BrandTemplatePreviewProvider = ({ children, templateBrandData }: BrandTemplatePreviewProps) => {
  /**
   * TODO: We can use reducer here to manage the state if it gets more complex
   */
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  // Fetch from prop templateBrandData, if not available then check cache
  const [brandTemplateData, setBrandTemplateData] = useState<BrandTemplateData | undefined>(
    templateBrandData ?? getLatestBrandTemplate(),
  );

  return (
    <BrandTemplatePreviewContext.Provider
      value={{
        isLoading,
        hasError,
        brandTemplateData,
        setIsLoading,
        setHasError,
        setBrandTemplateData,
      }}
    >
      {children}
    </BrandTemplatePreviewContext.Provider>
  );
};
